export { buildTimelineSnapPoints } from "./build";
export { resolveTimelineSnap } from "./resolve";
export { getTimelineSnapThresholdInTicks } from "./threshold";
export type {
	SnapPoint,
	SnapPointType,
	SnapResult,
	TimelineSnapPointSource,
} from "./types";
